module.exports = __webpack_public_path__ + "static/media/loader-black.9718bedc.svg";